
// Use this section for common items
export const COMMON = {
    FIRST_NAME: 'Common.First.Name',
    MIDDLE_NAME: 'Common.Middle.Name',
    LAST_NAME: 'Common.Last.Name',
    DOB: 'Common.DOB',
    EMAIL_ADDRESS: 'Common.Email.Address',
    RENTER_EMAIL_ADDRESS: 'Common.Renter.Email.Address',
    REQUIRED_TEXT: 'Common.Required.Text',
    REQUIRED_FIELD: 'Common.Required.Field',
    PHONE_NUMBER: 'Common.Phone.Number',
    SSN: 'Common.SSN',
    LAST4_SSN: 'Common.Last4.SSN',
    FULL_SSN: 'Common.Fullssn',
    VIN_REQUIRED: 'Common.VIN.Required',
    VIN_REQUIRED_PS: 'Common.VIN.Required.PS',
    VIN: 'Common.VIN',
    OPTIONAL: 'Common.Optional',
    ADDRESS_LINE1: 'Common.Address.Line1',
    ADDRESS_LINE2: 'Common.Address.Line2',
    CITY: 'Common.City',
    SELECT_STATE: 'Common.Select.State',
    ZIP_CODE: 'Common.Zip.Code',
    CONFIRMATION_NUM: "Common.Confirmation.Number",
    PIN: "Common.PIN",
    REQUESTED_REPORT: "Common.RequestedReport",
}

// Use this section for agent items
export const AGENT = {
  FIRST_NAME: 'Agent.First.Name',
  LAST_NAME: 'Agent.Last.Name',
  PHONE_NUMBER: 'Agent.Phone.Number',
};

//Use this section for button text
export const BUTTON = {
    CONTINUE: 'Button.Continue',
    DOWNLOAD: 'Button.Download',
    SUBMIT: 'Button.Submit',
    GO_TO_PRIVACY_PORTAL: 'Button.GoToPrivacyPortal',
    PRIVACY_POLICY: 'Button.PrivacyPolicy',
    SUBMIT_ANOTHER_REQUEST: 'Button.SubmitAnotherRequest',
    CONFIRM: 'Button.Confirm',
    CANCEL: 'Button.Cancel',
    EXIT: 'Button.Exit',
    VIEW_REQUEST_STATUS: 'Button.ViewRequestStatus',
    YES: "Button.Yes",  
    NO: "Button.No",
    SAVE: "Button.Save",
    UPDATE: "Button.Update",
    ACCEPT: "Button.Accept",
    TRY_AGAIN: "Button.TryAgain",
    CONTINUE_WITH: "Button.ContinueWith"
}

export const STATES = {
  ALBERTA: 'States.Alberta',
  BRITISH_COLUMBIA: 'States.BritishColumbia',
  MANITOBA: 'States.Manitoba',
  NEW_BRUNNSWICK: 'States.NewBrunswick',
  NEWFOUNDLAND_AND_LABRADOR: 'States.NewfoundlandAndLabrador',
  NOVA_SCOTIA: 'States.NovaScotia',
  ONTARIO: 'States.Ontario',
  PRINCE_EDWARD_AND_ISLAND: 'States.PrinceEdwardIsland',
  QUEBEC: 'States.Quebec',
  SASKATCHEWAN: 'States.Saskatchewan',
  NUNAVUT: 'States.Nunavut',
  NORTHWEST_TERRITORIES: 'States.NorthwestTerritories',
  YUKON: 'States.Yukon',
}

export const STATES_FR = {
  ALBERTA: 'States.Fr.Alberta',
  BRITISH_COLUMBIA: 'States.Fr.BritishColumbia',
  MANITOBA: 'States.Fr.Manitoba',
  NEW_BRUNNSWICK: 'States.Fr.NewBrunswick',
  NEWFOUNDLAND_AND_LABRADOR: 'States.Fr.NewfoundlandAndLabrador',
  NOVA_SCOTIA: 'States.Fr.NovaScotia',
  ONTARIO: 'States.Fr.Ontario',
  PRINCE_EDWARD_AND_ISLAND: 'States.Fr.PrinceEdwardIsland',
  QUEBEC: 'States.Fr.Quebec',
  SASKATCHEWAN: 'States.Fr.Saskatchewan',
  NUNAVUT: 'States.Fr.Nunavut',
  NORTHWEST_TERRITORIES: 'States.Fr.NorthwestTerritories',
  YUKON: 'States.Fr.Yukon',
}

export const MAINTENANCE_CONTENT = "maintenance.content";

export const STATE_SELECTION_CONTENT5_SUBMIT = "state.Selector.content.5.Submit";
export const STATE_SELECTION_CONTENT5_CHECK_STATUS = "state.Selector.content.5.CheckStatus";
export const STATE_SELECTION_HOUSEHOLDER_CONTENT1 = "state.Selector.Householder.content1";
export const STATE_SELECTION_HOUSEHOLDER_CONTENT2 = "state.Selector.Householder.content2";
export const STATE_SELECTION_HOUSEHOLDER_CONTENT3 = "state.Selector.Householder.content3";
export const STATE_SELECTION_HOUSEHOLDER_CONTENT4 = "state.Selector.Householder.content4";
export const STATE_SELECTION_HOUSEHOLDER_CONTENT5 = "state.Selector.Householder.content5";
export const STATE_SELECTION_HOUSEHOLDER_CONTENT6 = "state.Selector.Householder.content6";
export const STATE_SELECTION_HOUSEHOLDER_CONTENT7 = "state.Selector.Householder.content7";
export const STATE_SELECTION_NOTE1 = "state.Selector.Note1";
export const STATE_SELECTION_NOTE1_HYPERLINK = "state.Selector.Note1.Hyperlink";
export const STATE_SELECTION_NOTE2 = "state.Selector.Note2";
export const STATE_SUBMIT_BUTTON = "state.Selector.Button.Submit";
export const STATE_CHECK_STATUS = "state.Selector.Button.ChekStatus";
export const STATE_CALIFORNIA = "State.California";
export const STATE_VIRGINIA = "State.Virginia";
export const STATE_DELAWARE = "State.Delaware";
export const STATE_COLORADO = "State.Colorado";
export const STATE_CONNECTICUT = "State.Connecticut";
export const STATE_UTAH = "State.Utah";
export const STATE_TX = "State.Texas";
export const STATE_MONTANA = "State.Montana";
export const STATE_NEBRASKA = "State.Nebraska";
export const STATE_OREGON = "State.Oregon";
export const STATE_IOWA = "State.Iowa";
export const STATE_NEW_HAMPSHIRE = "State.NewHampshire";
export const STATE_NEW_JERSEY = "State.NewJersey";

export const STATE_QUEBEC = "State.Quebec";

export const STATE_QUESTION = 'State.Question';

export const QUESTIONNAIRE_MESSAGE_STATE_1 = "Questionnaire.Message.State.1";

export const UNSUPPORTED_STATE_MESSAGE = 'UnsupportedState.Message';

export const ON_BEHALF_QUESTION = 'OnBehalf.Question';
export const ON_BEHALF_QUESTION_CALI_ONLY = 'OnBehalf.Question.CaliOnly';
export const ON_BEHALF_OPTION_SELF = 'OnBehalf.Option.Self';
export const ON_BEHALF_OPTION_OTHER = 'OnBehalf.Option.Other';
export const ON_BEHALF_OPTION_OTHER_CA = 'OnBehalf.Option.Other.CA';
export const ON_BEHALF_OPTION_HOUSEHOLD = 'OnBehalf.Option.HouseHold';

export const ON_BEHALF_OTHER_MESSAGE1 = 'OnBehalf.Other.Message1';
export const ON_BEHALF_OTHER_MESSAGE_TX = 'OnBehalf.Other.Message.TX';
export const ON_BEHALF_OTHER_MESSAGE_CA = 'OnBehalf.Other.Message.CA';
export const ON_BEHALF_HOUSEHOLD_MESSAGE = 'OnBehalf.Household.Message';

export const BENTLEY_CUSTOMER_QUESTION = 'BentleyCustomer.Question';
export const BENTLEY_CUSTOMER_QUESTION_CALI_ONLY = "BentleyCustomer.Question.CaliOnly";
export const BENTLEY_CUSTOMER_QUESTION_VI_ONLY = "BentleyCustomer.Question.VIOnly";
export const BENTLEY_CUSTOMER_DESCRIPTION = 'BentleyCustomer.Description';
export const BENTLEY_CUSTOMER_OPTION_NON_BENTLEY = 'BentleyCustomer.Option.NonBentley';
export const BENTLEY_CUSTOMER_OPTION_BENTLEY = 'BentleyCustomer.Option.Bentley';
export const BENTLEY_CUSTOMER_DISABLED_OPTION_TOOLTIP = 'BentleyCustomer.DisabledOption.Tooltip';
export const BENTLY_CUSTOMER_DISABLED_OPTION_TOOLTIP_MAIL = 'BentleyCustomer.DisabledOption.Tooltip.Mail';
export const BRANDS_OPTION_VW_AUDI = "Brands.option.VW.Audi";
export const BRANDS_OPTION_VWFS_DFS_AFS = "Brands.option.VWFS.DFS.AFS";
export const BRANDS_OPTION_VWD_APP_DER = "Brands.option.VWDrive.AudiPP.DucatiER";
export const BRANDS_OPTION_VWFS_PROTECTION = "Brands.option.VWFS.ProtectionServices";

export const QUESTION_2 = 'Questionaire.Question.2';
export const QUESTION_4 = "Questionaire.Question.4";
export const QUESTION_2_CHECK = "Questionaire.Question.2.Check";
export const QUESTION_2_OPTION_1 = 'Questionaire.Question.2.Option.1';
export const QUESTION_2_OPTION_2 = 'Questionaire.Question.2.Option.2';
export const QUESTION_2_OPTION_3 = 'Questionaire.Question.2.Option.3';

export const QUESTION_2_TOOLTIP_CUSTOMER_HEADER = 'Questionaire.Question.2.Customer.Header';
export const QUESTION_2_TOOLTIP_CUSTOMER_DESCRIPTION = 'Questionaire.Question.2.Customer.Description';
export const QUESTION_2_TOOLTIP_PERSONNEL_HEADER = 'Questionaire.Question.2.Personnel.Header';
export const QUESTION_2_TOOLTIP_PERSONNEL_DESCRIPTION = 'Questionaire.Question.2.Personnel.Description';
export const QUESTION_2_TOOLTIP_REPRESENTATIVE_HEADER = 'Questionaire.Question.2.Representative.Header';
export const QUESTION_2_TOOLTIP_REPRESENTATIVE_DESCRIPTION = 'Questionaire.Question.2.Representative.Description';

export const INFO_FORM = {
  QUESTION: "InfoForm.Question",
  QUESTION_CA: "InfoForm.Question.CA",
  QUESTION_VA: "InfoForm.Question.VA",
  QUESTION_DNS: "InfoForm.Question.DNS",  
  QUESTION_DNS_BEHALF: "InfoForm.Question.Behalf",
  QUESTION_CANADA_QC_1: "InfoForm.Question.Canada.QC.1",
  QUESTION_CANADA_QC_2: "InfoForm.Question.Canada.QC.2",
  NOTE: "InfoForm.Note",
  NOTE_DNS_1:"InfoForm.Note.DNS.1",
  NOTE_DNS_2:"InfoForm.Note.DNS.2",
  NOTE_2: "InfoForm.Note.2",
  NOTE_3: "InfoForm.Note.3",
  REPORT_CATEGORY: "InfoForm.Report.Category",
  REPORT_CATEGORY_CARD_HEADER: "InfoForm.Report.Category.Card.Header",
  REPORT_CATEGORY_CARD_BODY0: "InfoForm.Report.Category.Card.Body.0",
  REPORT_CATEGORY_CARD_BODY1: "InfoForm.Report.Category.Card.Body.1",
  REPORT_CATEGORY_CARD_BODY2: "InfoForm.Report.Category.Card.Body.2",
  REPORT_CATEGORY_CARD_BODY4: "InfoForm.Report.Category.Card.Body.4",
  REPORT_CATEGORY_CARD_BODY5: "InfoForm.Report.Category.Card.Body.5",
  REPORT_CATEGORY_CARD_BODY_PS_TX_0: "InfoForm.Report.Category.Card.Body.TX.0",
  REPORT_CATEGORY_CARD_BODY_PS_TX_1: "InfoForm.Report.Category.Card.Body.TX.1",
  REPORT_CATEGORY_CARD_BODY_PS_TX_2: "InfoForm.Report.Category.Card.Body.TX.2",
  REPORT_CATEGORY_CARD_BODY_PS_TX_3: "InfoForm.Report.Category.Card.Body.TX.3",
  REPORT_CATEGORY_CARD_BODY_PS_TX_4: "InfoForm.Report.Category.Card.Body.TX.4",
  REPORT_CATEGORY_CARD_BODY_PS_TX_5: "InfoForm.Report.Category.Card.Body.TX.5",
  REPORT_CATEGORY_CARD_BODY_PS_CA_0: "InfoForm.Report.Category.Card.Body.CA.0",
  REPORT_CATEGORY_CARD_BODY_PS_CA_1: "InfoForm.Report.Category.Card.Body.CA.1",
  REPORT_CATEGORY_CARD_BODY_PS_CA_2: "InfoForm.Report.Category.Card.Body.CA.2",
  REPORT_CATEGORY_CARD_BODY_PS_CA_REP_OF_B_2: "InfoForm.Report.Category.Card.Body.CA.Rep.Of.B.2",
  REPORT_CATEGORY_CARD_BODY_PS_CA_3: "InfoForm.Report.Category.Card.Body.CA.3",
  REPORT_CATEGORY_CARD_BODY_PS_CA_4: "InfoForm.Report.Category.Card.Body.CA.4",
  REPORT_CATEGORY_CARD_BODY_PS_CA_REP_OF_B_4: "InfoForm.Report.Category.Card.Body.CA.Rep.Of.B.4",
  REPORT_CATEGORY_CARD_BODY_PS_CA_5: "InfoForm.Report.Category.Card.Body.CA.5",
  REPORT_SPECIFIC_PIECES: "InfoForm.Report.SpecificPieces",
  REPORT_SPECIFIC_PIECES_CARD_HEADER: "InfoForm.Report.SpecificPieces.Card.Header",
  REPORT_SPECIFIC_PIECES_CARD_BODY0: "InfoForm.Report.SpecificPieces.Card.Body.0",
  REPORT_SPECIFIC_PIECES_CARD_BODY1: "InfoForm.Report.SpecificPieces.Card.Body.1",
  REPORT_SPECIFIC_PIECES_CARD_BODY_NON_PS_1: "InfoForm.Report.SpecificPieces.Card.Body.Non.PS.1",
  REPORT_SPECIFIC_PIECES_CARD_BODY2: "InfoForm.Report.SpecificPieces.Card.Body.2",
  REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_0: "InfoForm.Report.SpecificPieces.Card.Body.CA.0",
  REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_1: "InfoForm.Report.SpecificPieces.Card.Body.CA.1",
  REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_2: "InfoForm.Report.SpecificPieces.Card.Body.CA.2",
  REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_3: "InfoForm.Report.SpecificPieces.Card.Body.CA.3",
  REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_4: "InfoForm.Report.SpecificPieces.Card.Body.CA.4",
  REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_5: "InfoForm.Report.SpecificPieces.Card.Body.CA.5",
  REPORT_SPECIFIC_PIECES_CARD_BODY_CANADA_QC_1: "InfoForm.Report.SpecificPieces.Card.Body.Canada.QC.1",
  REPORT_SPECIFIC_PIECES_CARD_BODY_CANADA_QC_2: "InfoForm.Report.SpecificPieces.Card.Body.Canada.QC.2",
  REPORT_SPECIFIC_PIECES_CARD_BODY_CANADA_QC_3: "InfoForm.Report.SpecificPieces.Card.Body.Canada.QC.3",
  DATE_REQUIRED: "InfoForm.Date.Required",
  DATE_AGE_RESTRICTION: "InfoForm.Date.AgeRestriction",
};

export const MAILING_ADDRESS = {
    MODAL_TITLE: "MailingAddress.Modal.Title",
    REPORT_LABEL: "MailingAddress.Report.Label",
    ENTERED_ADDRESS: "MailingAddress.Entered.Address",
    REENTER_ADDRESS: "MailingAddress.reEnter.Address",
    USEENTERED_ADDRESS: "MailingAddress.useEntered.Address",
    SUGGESTED_ADDRESS: "MailingAddress.Suggested.Address",
    USE_ENTERED_ADDRESS: "MailingAddress.Use.Entered.Address"
};

export const DELETE_REQUEST_CONFIRMATION = "DeleteRequestConfirmation";

export const REQUEST_SELECTOR = {
  TITLE_QUESTION: "RequestSelector.Title.Question",
  TITLE_QUESTION_CHECK: "RequestSelector.Title.Question.Check",
  DO_NOT_SELL_INFO: "RequestSelector.DoNotSell",
  DELETE_INFO: "RequestSelector.DeleteMyInfo",
  ACCESS_INFO: "RequestSelector.AccessMyInfo",
  KNOW_INFO: "RequestSelector.KnowMyInfoQC",
  DO_NOT_USE_INFO: "RequestSelector.DoNotUseInfo",
  CORRECT_MY_DATA: "RequestSelector.CorrectMyData",
  LIMIT_DATA: "RequestSelector.LimitData",
  OPT_OUT: "RequestSelector.OptOut",
  WITHDRAW: "RequestSelector.Withdraw",
  DO_NOT_SELL_INFO_QC: "RequestSelector.DoNotSell.QC",
  DELETE_INFO_QC: "RequestSelector.DeleteMyInfo.QC",
  ACCESS_INFO_QC: "RequestSelector.AccessMyInfo.QC",
  KNOW_INFO_QC: "RequestSelector.KnowMyInfoQC.QC",
  DO_NOT_USE_INFO_QC: "RequestSelector.DoNotUseInfo.QC",
  CORRECT_MY_DATA_QC: "RequestSelector.CorrectMyData.QC",
  LIMIT_DATA_QC: "RequestSelector.LimitData.QC",
  OPT_OUT_QC: "RequestSelector.OptOut.QC",
  WITHDRAW_QC: "RequestSelector.Withdraw.QC",
  DO_NOT_SELL_INFO_CARD_HEADER: "RequestSelector.DoNotSell.CardHeader",
  DO_NOT_SELL_INFO_CARD_BODY1: "RequestSelector.DoNotSell.CardBody1",
  DO_NOT_SELL_INFO_CARD_BODY2: "RequestSelector.DoNotSell.CardBody2",
  DO_NOT_SELL_INFO_CARD_BODY_VA1: "RequestSelector.DoNotSell.CardBody.VA1",
  DO_NOT_SELL_INFO_CARD_BODY_VA2: "RequestSelector.DoNotSell.CardBody.VA2",
  DO_NOT_SELL_INFO_CARD_BODY_CA1: "RequestSelector.DoNotSell.CardBody.CA1",
  DO_NOT_SELL_INFO_CARD_BODY_CA2: "RequestSelector.DoNotSell.CardBody.CA2",
  DATA_CORRECTION_CARD_BODY: "RequestSelector.DataCorrection.CardBody",
  DELETE_INFO_CARD_HEADER: "RequestSelector.DeleteMyInfo.CardHeader",
  DELETE_INFO_CARD_BODY1: "RequestSelector.DeleteMyInfo.CardBody1",
  DELETE_INFO_CARD_BODY1_CA: "RequestSelector.DeleteMyInfo.CardBody1.CA",
  DELETE_INFO_CARD_BODY1_VA: "RequestSelector.DeleteMyInfo.CardBody1.VA",
  DELETE_INFO_CARD_BODY1_QC: "RequestSelector.DeleteMyInfo.CardBody1.QC",
  ACCESS_INFO_CARD_BODY_QC: "RequestSelector.AccessMyInfo.CardBody.QC",
  WITHDRAW_CARD_BODY_QC_1: "RequestSelector.Withdraw.CardBody.QC.1",
  WITHDRAW_CARD_BODY_QC_2: "RequestSelector.Withdraw.CardBody.QC.2",
  WITHDRAW_CARD_BODY_QC_3: "RequestSelector.Withdraw.CardBody.QC.3",
  WITHDRAW_CARD_BODY_QC_4: "RequestSelector.Withdraw.CardBody.QC.4",
  ACCESS_INFO_CARD_HEADER: "RequestSelector.AccessMyInfo.CardHeader",
  ACCESS_INFO_CARD_BODY1: "RequestSelector.AccessMyInfo.CardBody1",
  ACCESS_INFO_CARD_BODY2: "RequestSelecter.AccessMyInfo.CardBody2",
  TEXT_SELECT_THIS_REQUEST: "RequestSelector.Text.SelectThisRequest",
  TEXT_REQUEST_DESCRIPTION: "RequestSelector.Text.RequestDescription",
  VA_BOTTOM_TEXT1: "RequestSelector.VA_BottomText1",
  VA_BOTTOM_TEXT2: "RequestSelector.VA_BottomText2",
  VA_CA_BOTTOM_TEXT2: "RequestSelector.VA_CA_BottomText2",
  VA_CA_BOTTOM_TEXT1OF3: "RequestSelector.VA_CA_BottomText1of3",
  VA_CA_BOTTOM_TEXT2OF3: "RequestSelector.VA_CA_BottomText2of3",
  VA_CA_BOTTOM_TEXT3OF3: "RequestSelector.VA_CA_BottomText3of3",
  VA_CA_BOTTOM_TEXT4: "RequestSelector.VA_CA_BottomText4",
  VA_CA_BOTTOM_TEXT5: "RequestSelector.VA_CA_BottomText5",
  VA_CA_BOTTOM_TEXT1OF6: "RequestSelector.VA_CA_BottomText1of6",
  VA_CA_BOTTOM_TEXT2OF6: "RequestSelector.VA_CA_BottomText2of6",
  VA_CA_BOTTOM_TEXT3OF6: "RequestSelector.VA_CA_BottomText3of6",
  VA_BOTTOM_TEXT7: "RequestSelector.VA_BottomText7",
  CA_BOTTOM_TEXT1: "RequestSelector.CA_BottomText1",
  CA_BOTTOM_TEXT7: "RequestSelector.CA_BottomText7",
  CA_BOTTOM_TEXT8: "RequestSelector.CA_BottomText8",
  CA_BOTTOM_TEXT9: "RequestSelector.CA_BottomText9",
  CA_BOTTOM_TEXT10: "RequestSelector.CA_BottomText10",
  CA_BOTTOM_TEXT11: "RequestSelector.CA_BottomText11",
  CA_BOTTOM_TEXT12: "RequestSelector.CA_BottomText12",
  CA_BOTTOM_TEXT13: "RequestSelector.CA_BottomText13",
  CA_BOTTOM_TEXT1OF14: "RequestSelector.CA_BottomText1of14",
  CA_BOTTOM_TEXT2OF14: "RequestSelector.CA_BottomText2of14",
  CA_BOTTOM_TEXT15: "RequestSelector.CA_BottomText15",
  CA_BOTTOM_TEXT16: "RequestSelector.CA_BottomText16",
  CA_BOTTOM_TEXT17: "RequestSelector.CA_BottomText17",

  QC_BOTTOM_TEXT_1: "RequestSelector.QC_BottomText1",
  QC_BOTTOM_TEXT_2: "RequestSelector.QC_BottomText2",
  QC_BOTTOM_TEXT_2_1_1: "RequestSelector.QC_BottomText2_1_1",
  QC_BOTTOM_TEXT_2_1_2: "RequestSelector.QC_BottomText2_1_2",
  QC_BOTTOM_TEXT_2_1_3: "RequestSelector.QC_BottomText2_1_3",
  QC_BOTTOM_TEXT_2_2: "RequestSelector.QC_BottomText2_2",
  QC_BOTTOM_TEXT_2_3: "RequestSelector.QC_BottomText2_3",
  QC_BOTTOM_TEXT_3: "RequestSelector.QC_BottomText3",
  QC_BOTTOM_TEXT_3_1_1: "RequestSelector.QC_BottomText3_1_1",
  QC_BOTTOM_TEXT_3_1_2: "RequestSelector.QC_BottomText3_1_2",
  QC_BOTTOM_TEXT_3_1_3: "RequestSelector.QC_BottomText3_1_3",
  QC_BOTTOM_TEXT_3_2: "RequestSelector.QC_BottomText3_2",
  QC_BOTTOM_TEXT_3_3: "RequestSelector.QC_BottomText3_3",
  QC_BOTTOM_TEXT_5: "RequestSelector.QC_BottomText5",
  QC_BOTTOM_TEXT_5_1_1: "RequestSelector.QC_BottomText5_1_1",
  QC_BOTTOM_TEXT_5_1_2: "RequestSelector.QC_BottomText5_1_2",
  QC_BOTTOM_TEXT_5_1_3: "RequestSelector.QC_BottomText5_1_3",
  QC_BOTTOM_TEXT_6: "RequestSelector.QC_BottomText6",
  QC_BOTTOM_TEXT_7: "RequestSelector.QC_BottomText7",
  QC_BOTTOM_TEXT_8: "RequestSelector.QC_BottomText8"
};

export const CHECK_STATUS = {
  SPECIFIC_PIECES_REPORT: "CheckStatus.SpecificPiecesReport",
  CATEGORIES_REPORT: "CheckStatus.CategoriesReport",
};

export const REQUEST_RIGHT ={
    ACCESS_INFO_LINE1: "RequestRight.AccessInfo.Line1",
}

export const VERFICIATION_FORM ={
    TITLE: "Verification.Title",
    PIN_HINT_MESSAGE : "Verification.Pin.hint",
    NOTE2 : "Verification.Note2",
    NOTE1 : "Verification.Note1"
};

export const EXPERIAN_FORM = {
    CONTENT1 : "Experian.content1",
    CONTENT2 : "Experian.content2",
    CONTENT3 : "Experian.content3",
    PROTECTION_SERVICES_CONTENT_CHECK : "Experian.ProtectionServices.Content.Check",
    PROTECTION_SERVICES_CONTENT_SUBMIT: "Experian.ProtectionServices.Content.Submit",
    API_VERIFY_ERROR: "Experian.API.VerifyError",
    API_CONSUMER_NOT_FOUND_RESPONSE: "Experian.API.ConsumerNotFoundResponse",
}

export const KNOW_MY_INFO_FORM = {
    THANK_YOU: 'KnowMyInfo.Form.ThankYou',
};

export const DNS_FORM = {
   THANK_YOU: "Dns.Form.ThankYou",
};

export const DNU_FORM = {
    THANK_YOU : 'Dnu.Form.ThankYou',
};

export const DELETE_FORM = {
    HEADER: "Delete.Form.Header.Text",
    LINE1: "Delete.Form.Request.Line1",
    THANK_YOU: 'Delete.Form.ThankYou',
    HOMESCREEN_BUTTON:"Delete.Form.Homescreen.button",
};

export const DATA_CORRECTION_FORM = {
    THANK_YOU : "DataCorrection.Form.ThankYou",
};

export const LIMIT_DATA_FORM = {
    THANK_YOU : "LimitData.Form.ThankYou",
};

export const CREATE_PIN_FORM = {
    TITLE : "PinForm.Text",
    PIN_NUMBER : "PinForm.PinNumber",
    REENTER_PIN_NUMBER : "PinForm.ReEnterPinNumber",
    PIN_DONT_MATCH: "Pin.DontMatch",
    PIN_INVALID: "Pin.Invalid",
    NOTE: "Pinform.Note"
};

export const CCPA_FORM_ERROR = {
    FIRST_NAME_ERROR : 'First.Name.Error.Message',
    MIDDLE_NAME_ERROR : 'Middle.Name.Error.Message',
    LAST_NAME_ERROR : 'Last.Name.Error.Message',
    DOB_ERROR : 'Dob.Error.Message',
    EMAIL_ADDRESS_ERROR : 'Email.Error.Message',
    REENTER_ADDRESS_ERROR : 'Reenter.Email.Error.Message',
    PHONE_NUMBER_ERROR : 'Phone.Number.Error.Message',
    LAST4_SSN_ERROR : 'Last4SSN.Error.Message',
    FULL_SSN_ERROR : 'Full.SSN.Error.Message',
    VIN_NUMBER_ERROR : 'VIN.Error.Message',
    ADDRESS_LINE_ERROR: 'Address.Error.Message',
    CITY_ERROR : 'City.Error.Message',
    STATE_ERROR : 'State.Error.Message',
    ZIP_CODE_ERROR : 'Zip.Error.Message',
    CONFIRMATION_NUM_ERROR : 'Confirmation.Error.Message',
    CONFIRMATION_NUM_ERROR_VWGOA : 'Confirmation.Error.Message.VWGoA',
    PIN_NUM_ERROR : 'Pin.Error.Message'

}

export const ERROR_REQUIRED = "Error.Required";
export const EMAIL_DONT_MATCH = "Email.Required";

export const ERROR_STRIKEIRON = "Error.StrikeIron";

export const ERROR_API_FAIL = "Error.ApiFail";
export const ERROR_ISVWGOA_MESS1 = "Error.IsVwgoaMess.1";
export const ERROR_ISVWGOA_MESS2 = "Error.IsVwgoaMess.2";

export const ERROR_DOCUMENT_NOT_FOUND = "Error.DocumentNotFound";
export const ERROR_USER_NOT_FOUND = "Error.UserNotFound";

export const STATUS_FORM = {
    TYPE_HEADER : "StatusForm.Type.Header.Text",
    DOWNLOAD_HEADER : "StatusForm.Download.Header.Text",
    DATE_REQUESTED_HEADER : "StatusForm.Date.Requested.Header.Text",
    DATE_REQUESTED_MUTED_TEXT : "StatusForm.Date.Requested.Muted.Text",
    PENDING_MUTED_TEXT : "StatusForm.Date.Pending.Muted.Text",
    PENDING_TEXT : "StatusForm.Pending.Text",
    CANCELED_TEXT : "StatusForm.Canceled.Text",
    NOT_FOUND_TEXT : "StatusForm.NotFound.Text",
    STATUS_HEADER : "StatusForm.Status.Header.Text",
    DO_NOT_SELL_REQUEST : "StatusForm.Request.DoNotSell",
    BRAND_REQUEST : "StatusForm.Request.Brand",
    VCI_REQUEST : "StatusForm.Request.VCI",
    DELETE_INFO_REQUEST : "StatusForm.Request.DeleteInfo",
    BRAND_TIER1_REQUEST : "StatusForm.Request.Brand.Tier1",
    BRAND_TIER2_REQUEST : "StatusForm.Request.Brand.Tier2",
    VCI_TIER1_REQUEST  : "StatusForm.Request.VCI.Tier1",
    VCI_TIER2_REQUEST  : "StatusForm.Request.VCI.Tier2",
    TIER1_REQUEST : "StatusForm.Request.Tier1",
    TIER2_REQUEST : "StatusForm.Request.Tier2",
    SELECT_DEFAULT  : "StatusForm.Dropdown.Default",
    SELECT_JSON  : "StatusForm.Dropdown.Json",
    SELECT_PDF  : "StatusForm.Dropdown.Pdf",
    SELECT_ZIP  : "StatusForm.Dropdown.Zip",
    TOOLTIP_TEXT : "StatusForm.Tooltip.Text",
    PENDING : "Status.Pending",
    CANCELED : "Status.Canceled",
    NOT_FOUND : "Status.NotFound",
    COMPLETED : "Status.Completed",
}

export const DATA_CORRECTION = {
  LANDING_TEXT: "DataCorrection.Landing.Text",
  LANDING_BUTTON: "DataCorrection.Landing.Button",
  LANDING_BUTTON_B2B: "DataCorrection.Landing.Button.B2B",
  LANDING_BUTTON_2: "DataCorrection.Landing.Button2",
  LANDING_BUTTON_2_B2B: "DataCorrection.Landing.Button2.B2B",
  INFO: "DataCorrection.Info",
  PENDING_CHANGES: "DataCorrection.PendingChanges",
  NAME_LABEL: "DataCorrection.NameLabel",
  EMAIL_LABEL: "DataCorrection.EmailLabel",
  PHONE_NUMBER_LABEL: "DataCorrection.PhoneNumberLabel",
  ADDRESS_LABEL: "DataCorrection.AddressLabel",
  VWGOA_SUBMIT_COPY: "DataCorrection.VWGoA.SubmitText",
  MY_VW_INSTRUCTION_TITLE: "DataCorrection.MyVW.InstructionTitle",
  MY_AUDI_INTRUCTION_TITLE: "DataCorrection.MyAudi.InstructionTitle",
  MY_VW_INTRUCTION: {
    ONE: "DataCorrection.MyVW.Intruction.One",
    TWO: "DataCorrection.MyVW.Intruction.Two",
    THREE: "DataCorrection.MyVW.Intruction.Three",
  },
  MY_AUDI_INTRUCTION: {
    ONE: "DataCorrection.MyAudi.Intruction.One",
  },
  VCI: {
    CURRENT_CUSTOMER: "DataCorrection.VCI.CurrentCustomer",
    CURRENT_CUSTOMER_TEXT_1: "DataCorrection.VCI.CurrentCustomerText",
    CURRENT_CUSTOMER_TEXT_2: "DataCorrection.VCI.CurrentCustomerText2",
    CURRENT_CUSTOMER_TEXT_3: "DataCorrection.VCI.CurrentCustomerText3",
    CURRENT_CUSTOMER_TEXT_4: "DataCorrection.VCI.CurrentCustomerText4",
    CURRENT_CUSTOMER_TEXT_5: "DataCorrection.VCI.CurrentCustomerText5",
    CURRENT_CUSTOMER_WITH_NO_ACCOUNT:
      "DataCorrection.VCI.CurrentCustomerWithNoAccount",
    VWCREDIT_CONTACT: "DataCorrection.VCI.VWCredit.Contact",
    AFS_CONTACT: "DataCorrection.VCI.AFS.Contact",
    DFS_CONTACT: "DataCorrection.VCI.DFS.Contact",
    REPRESENTATIVE: "DataCorrection.VCI.Rep",
    CURRENT_CUSTOMER_BULLET_AUDI: "DataCorrection.VCI.CurrentCustomerAudi",
    CURRENT_CUSTOMER_BULLET_VW: "DataCorrection.VCI.CurrentCustomerVW",
    AFS_CURRENT_CUSTOMER_BULLET_1: "DataCorrection.VCI.AFS.CurrentCustomerBullet1",
    AFS_CURRENT_CUSTOMER_BULLET_2: "DataCorrection.VCI.AFS.CurrentCustomerBullet2",
    AFS_CURRENT_CUSTOMER_BULLET_2_CANADA_1: "DataCorrection.VCI.AFS.CurrentCustomerBullet2.Canada.1",
    AFS_CURRENT_CUSTOMER_BULLET_2_CANADA_AF: "DataCorrection.VCI.AFS.CurrectCustomerBullet2.Canada.AF",
    AFS_CURRENT_CUSTOMER_BULLET_2_CANADA_AFLINK: "DataCorrection.VCI.AFS.CurrectCustomerBullet2.Canada.AFLink",
    AFS_CURRENT_CUSTOMER_BULLET_2_CANADA_2: "DataCorrection.VCI.AFS.CurrentCustomerBullet2.Canada.2",
    AFS_CURRENT_CUSTOMER_BULLET_3: "DataCorrection.VCI.AFS.CurrentCustomerBullet3",
    AFS_CURRENT_CUSTOMER_BULLET_4: "DataCorrection.VCI.AFS.CurrentCustomerBullet4",
    AFS_CURRENT_CUSTOMER_BULLET_5: "DataCorrection.VCI.AFS.CurrentCustomerBullet5",
    VWC_CURRENT_CUSTOMER_BULLET_1: "DataCorrection.VCI.VWC.CurrentCustomerBullet1",
    VWC_CURRENT_CUSTOMER_BULLET_2: "DataCorrection.VCI.VWC.CurrentCustomerBullet2",
    VWC_CURRENT_CUSTOMER_BULLET_2_CANADA_1: "DataCorrection.VCI.VWC.CurrentCustomerBullet2.Canada.1",
    VWC_CURRENT_CUSTOMER_BULLET_2_CANADA_VF: "DataCorrection.VCI.VWC.CurrectCustomerBullet2.Canada.VF",
    VWC_CURRENT_CUSTOMER_BULLET_2_CANADA_VFLINK: "DataCorrection.VCI.VWC.CurrectCustomerBullet2.Canada.VFLink",
    VWC_CURRENT_CUSTOMER_BULLET_2_CANADA_2: "DataCorrection.VCI.VWC.CurrentCustomerBullet2.Canada.2",
    VWC_CURRENT_CUSTOMER_BULLET_3: "DataCorrection.VCI.VWC.CurrentCustomerBullet3",
    VWC_CURRENT_CUSTOMER_BULLET_4: "DataCorrection.VCI.VWC.CurrentCustomerBullet4",
    VWC_CURRENT_CUSTOMER_BULLET_5: "DataCorrection.VCI.VWC.CurrentCustomerBullet5",
    VWC_CURRENT_CUSTOMER_BULLET_6: "DataCorrection.VCI.VWC.CurrentCustomerBullet6",
    EMPLOYEE_TEXT_1: "DataCorrection.VCI.EmployeeOrRepText1",
    EMPLOYEE_TEXT_2: "DataCorrection.VCI.EmployeeOrRepText2",
    EMPLOYEE_NOTE_1: "DataCorrection.VCI.Note1",
    EMPLOYEE_NOTE_2: "DataCorrection.VCI.Note2",
    EMPLOYEE_NOTE_2_1: "DataCorrection.VCI.Note2_1",
    EMPLOYEE_NOTE_2_2: "DataCorrection.VCI.Note2_2",
    EMPLOYEE_NOTE_3: "DataCorrection.VCI.Note3",
    EMPLOYEE_NOTE_3_1: "DataCorrection.VCI.Note3_1",
    EMPLOYEE_NOTE_3_2: "DataCorrection.VCI.Note3_2",
    EMPLOYEE_NOTE_3_3: "DataCorrection.VCI.Note3_3",
    EMPLOYEE_NOTE_4: "DataCorrection.VCI.Note4",
    EMPLOYEE_NOTE_4_1: "DataCorrection.VCI.Note4_1",
    EMPLOYEE_NOTE_4_1_1: "DataCorrection.VCI.Note4_1_1",
    EMPLOYEE_NOTE_4_1_2: "DataCorrection.VCI.Note4_1_2",
    EMPLOYEE_NOTE_4_1_3: "DataCorrection.VCI.Note4_1_3",
    EMPLOYEE_NOTE_4_2: "DataCorrection.VCI.Note4_2",
    EMPLOYEE_NOTE_4_2_1: "DataCorrection.VCI.Note4_2_1",
    EMPLOYEE_NOTE_4_2_2: "DataCorrection.VCI.Note4_2_2",
    EMPLOYEE_NOTE_4_2_3: "DataCorrection.VCI.Note4_2_3",
    EMPLOYEE_NOTE_4_2_4: "DataCorrection.VCI.Note4_2_4",
    EMPLOYEE_NOTE_4_3: "DataCorrection.VCI.Note4_3",
    EMPLOYEE_TEXT_3: "DataCorrection.VCI.EmployeeOrRepText3",
    EMPLOYEE_NEW_REQUEST_TEXT_1: "DataCorrection.VCI.EmployeeOrRepNewRequestText1",
    EMPLOYEE_NEW_REQUEST_TEXT_2: "DataCorrection.VCI.EmployeeOrRepNewRequestText2",
    EMPLOYEE_NEW_REQUEST_TEXT_3: "DataCorrection.VCI.EmployeeOrRepNewRequestText3",
    EMPLOYEE_MY_SERVE_LINK: "DataCorrection.VCI.EmployeeOrRep.MyServeLink",
    CUSTOMER_CTA_1: "DataCorrection.VCI.CustomerCTA1",
    CUSTOMER_CTA_2: "DataCorrection.VCI.CustomerCTA2",
    EMPLOYEE_OR_REP_CTA: "DataCorrection.VCI.EmployeeOrRepCTA",
  },
  BOTTOM_TEXT1: "DataCorrection.BottomText1",
  BOTTOM_TEXT2: "DataCorrection.BottomText2",
  BOTTOM_TEXT3: "DataCorrection.BottomText3",
};

export const WITHDRAW = {
  TITLE: "Withdraw.Title",
};

export const FOOTER = {
    VWCREDIT : "Footer.VWCredit",
    VWCREDIT_CA: "Footer.VWCredit.CA",
    T_AND_C: "Footer.TandC",
    LANGUAGE_ENGLISH: "Footer.Language.English",
    LANGUAGE_FRENCH: "Footer.Language.French",
}

export const PORTAL_DISABLED_MESSAGE = "Portal.Disabled.Message";

export const SECURE_KEY = {
  DESCRIPTION: "SecureKey.Modal.Description",
  FOOTER: "SecureKey.Footer.Description",
  PHONE_NUMBER_1: "SecureKey.Footer.Phone1",
  PHONE_NUMBER_2: "SecureKey.Footer.Phone2",
  PHONE_NUMBER_DESCRIPTION: "SecureKey.Phone.Description",
  NETWORK_ERROR_TITLE: "SecureKey.Network.Title",
  NETWORK_ERROR_DESCRIPTION: "SecureKey.Network.Description",
  AUTHENTICATION_ERROR_TITLE: "SecureKey.Authentication.Title",
  AUTHENTICATION_ERROR_DESCRIPTION: "SecureKey.Authentication.Description",
}

export const AGENT_SUBMIT = {
  TooltipContent: "AgentSubmit.Tooltip.Content",
}
